// extracted by mini-css-extract-plugin
module.exports = {"paymentIcon":"Style_paymentIcon__2BIQV","sslIcon":"Style_sslIcon__3xPQW","title":"Style_title__TRupl","container":"Style_container__z_S9U"};